import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod";
import { useLingui } from "@lingui/react/macro";
import { ActivityLogTable } from "@/components/activity/ActivityLogTable";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/(protected)/_layout/admin/audit")({
  validateSearch: (search) =>
    z
      .object({
        entityType: z.string().optional(),
      })
      .parse(search),
  component: AuditLogPage,
});

function AuditLogPage() {
  const { t } = useLingui();
  const { entityType } = Route.useSearch();
  const { isAuthenticated, isLoading, hasRole, hasPermission } = useAuth();

  if (isLoading) return null;

  const canView =
    hasPermission("audit:read") || hasRole("SUPER_ADMIN") || hasRole("SUPPORT");
  if (!isAuthenticated || !canView) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="flex flex-col gap-6 p-4 lg:p-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-(--color-text-primary)">
          {t`Audit Logs`}
        </h1>
        <p className="mt-1 text-(--color-text-secondary)">
          {entityType
            ? t`Organization-wide ${entityType} activity.`
            : t`Organization-wide activity across all entities.`}
        </p>
      </div>
      <ActivityLogTable scope={entityType ? { entityType } : undefined} showActor />
    </div>
  );
}
